export default `{
  "reject_requests": ["someurl.com/style.css"]
}`